import type { CityConfig } from "../city-template/types";

export const federalHeightsConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Federal Heights",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "federal-heights",
  route: "/federal-heights",
  title: "Emergency Passport Federal Heights, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Federal Heights, Colorado — as fast as 24 hours. Same-day courier processing for Federal Heights, Northglenn, Westminster, Thornton, and all northern Adams County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Federal Heights, CO",
  heroSubtitle: "Last-minute trip to Mexico and your passport just expired? Family visiting relatives abroad next week? We help Federal Heights residents — from Water World families to Federal Boulevard corridor residents to Adams County professionals — get their passports quickly. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Federal%20Heights%20Colorado%20small%20suburban%20city%20landscape%20with%20Water%20World%20water%20park%20visible%20as%20a%20colorful%20landmark%20in%20the%20foreground%2C%20the%20Front%20Range%20Rocky%20Mountains%20rising%20on%20the%20western%20horizon%20with%20snow%20dusted%20peaks%2C%20residential%20neighborhoods%20with%20modest%20homes%20and%20tree%20lined%20streets%2C%20the%20Federal%20Boulevard%20corridor%20with%20local%20businesses%20and%20traffic%2C%20bright%20Colorado%20summer%20day%20with%20dramatic%20cumulus%20clouds%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20cinematic%20view%20with%20vibrant%20natural%20tones&width=1800&height=700&seq=federalheights-hero-001&orientation=landscape",
  heroImageAlt: "Federal Heights Colorado with Water World landmark and Rocky Mountain views",
  geoPosition: "39.8661;-105.0172",
  geoPlacename: "Federal Heights, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 25 miles southeast via US-36 and I-225 — about 30–35 minutes",
  },
  nearbyCitiesZips: [
    { name: "Federal Heights", zips: "80260" },
    { name: "Northglenn", zips: "80233, 80234, 80260" },
    { name: "Westminster", zips: "80031, 80030, 80021" },
    { name: "Thornton", zips: "80241, 80229, 80602" },
    { name: "Denver", zips: "80216, 80221, 80211" },
    { name: "Commerce City", zips: "80022" },
    { name: "Broomfield", zips: "80020, 80021" },
    { name: "Arvada", zips: "80002, 80003" },
    { name: "Welby", zips: "80229" },
    { name: "Sherrelwood", zips: "80221" },
    { name: "Twin Lakes", zips: "80221" },
    { name: "Berkley", zips: "80221" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Federal Heights international departures via DEN" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — skip the drive to Aurora" },
    { icon: "ri-flight-takeoff-line", title: "US-36 Corridor Access", desc: "Direct US-36 access to Denver and Boulder — centrally located" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from UPS or FedEx in Northglenn, Westminster, or Thornton" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/denver" },
    { name: "Emergency passport help in Northglenn, CO", route: "/northglenn" },
    { name: "Fast passport renewal in Federal Heights area", route: "/federal-heights" },
    { name: "Urgent passport services for Westminster and Thornton", route: "/westminster-co" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services in Broomfield and Arvada", route: "/broomfield" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Federal Heights remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Federal Heights' central location near the US-36/I-25 junction — just 25 miles from the Colorado Passport Agency — makes our courier service the smartest choice. Skip the drive through metro traffic and let us handle everything.",
  fpcOfficeAddress: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
  fpcOfficeDistance: "Serving all of Federal Heights and the northern Adams County/US-36 corridor communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Federal Heights and the surrounding northern metro area. From the neighborhoods near Water World to the Federal Boulevard corridor, from the communities along 92nd Avenue to the residential areas near Camenisch Park — we serve every corner of Federal Heights and the surrounding communities.",
  nearbyCitiesIntro: "We serve Federal Heights and all nearby communities including Northglenn, Westminster, Thornton, Broomfield, Arvada, Commerce City, Welby, Sherrelwood, and the northern Denver suburbs.",
  howItWorksIntro: "Most Federal Heights travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — you never need to navigate US-36 and I-225 through metro Denver.",
  mistakesIntro: "Federal Heights is a small, well-positioned city in the northern metro area — home to Water World and conveniently located along the US-36 corridor. Here are the most common passport mistakes we see from Federal Heights-area travelers.",
  testimonialsIntro: "Federal Heights travelers — from Water World-area families to US-36 corridor commuters to long-time Adams County residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Federal Heights, CO? Here are the most common ones we hear from northern metro travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Aurora (30–35 minutes each way)", "US-36 to I-225 traffic can be heavy"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Aurora drive required — ship from Federal Heights area", "Perfect for family vacations and visiting relatives abroad", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Federal Heights travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest service available without fighting US-36 and I-225 traffic.",
      bullets: ["24–48 hour turnaround available", "DIA (DEN) departure support via US-36/E-470", "Family and business travel expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Federal Heights adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Federal Heights address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Federal Heights residents and Adams County families — including young adults and new citizens.",
      bullets: ["Acceptance facility scheduling in nearby Northglenn or Westminster", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Federal Heights residents who lost their passport before international travel — business or family.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Federal Heights and northern metro families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Federal Heights and Adams County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Federal Heights CO", description: "Urgent passport processing for Federal Heights Colorado travelers with immediate departure needs from DEN." },
    { name: "Expedited Passport Renewal Federal Heights CO", description: "Fast passport renewal for Federal Heights Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Federal Heights CO", description: "New passport application services for Federal Heights Colorado residents applying for their first passport." },
    { name: "Child Passport Federal Heights CO", description: "Minor passport services for Federal Heights Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Maria H.",
      location: "Federal Heights, CO — Near Water World",
      rating: 5,
      text: "Family trip to see relatives in Guadalajara and our kids' passports had expired. Fast Passport Center handled all three renewals in 5 days. Being in Federal Heights, the nearby UPS Store in Northglenn made shipping super easy.",
      service: "Family Passport Bundle",
    },
    {
      name: "Jose R.",
      location: "Federal Heights, CO — Federal Boulevard",
      rating: 5,
      text: "Work trip to Toronto with just 6 days notice. Needed my passport renewed fast. Fast Passport Center got it done in 3 days. Didn't have to deal with a single minute of US-36 traffic to Denver.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Linda K.",
      location: "Federal Heights, CO — 92nd Avenue Area",
      rating: 5,
      text: "First passport ever at age 62 for a cruise to Alaska. Fast Passport Center walked me through the entire DS-11 process and had my passport in 5 days. So grateful for their patience with a first-timer.",
      service: "First-Time Passport",
    },
    {
      name: "Robert S.",
      location: "Sherrelwood, CO",
      rating: 5,
      text: "Lost my passport somewhere during a move and had a trip to London booked. Fast Passport Center replaced it in 48 hours. The courier service is a lifesaver — no need to drive across town.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "fh-1",
      name: "Northglenn Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11887 Washington St",
      city: "Northglenn",
      state: "CO",
      zip: "80233",
      phone: "(303) 451-1666",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 2 miles north of Federal Heights, in Northglenn",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Closest acceptance facility to Federal Heights. Convenient access from Federal Boulevard. Appointments recommended — book ahead during peak seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "fh-2",
      name: "Westminster Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7351 Federal Blvd",
      city: "Westminster",
      state: "CO",
      zip: "80030",
      phone: "(303) 426-5911",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 3 miles west of Federal Heights, in Westminster",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Western acceptance facility. Good alternative to Northglenn — often has better appointment availability. Federal Boulevard corridor access.",
      icon: "ri-mail-line",
    },
    {
      id: "fh-3",
      name: "Thornton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8700 Grant St",
      city: "Thornton",
      state: "CO",
      zip: "80229",
      phone: "(303) 853-9940",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Approximately 4 miles east of Federal Heights, in Thornton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Extended hours (open until 5PM). Larger facility with more appointment slots. Good for after-work appointments.",
      icon: "ri-mail-line",
    },
    {
      id: "fh-4",
      name: "Adams County Clerk & Recorder",
      type: "County Clerk Passport Acceptance",
      address: "4430 S Adams County Pkwy",
      city: "Brighton",
      state: "CO",
      zip: "80601",
      phone: "(720) 523-6100",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Approximately 15 miles northeast of Federal Heights, in Brighton",
      website: "https://www.adamscountyco.gov/",
      websiteLabel: "Adams County Clerk",
      notes: "County government passport acceptance. Early morning hours (8AM). Serves all Adams County residents including Federal Heights. Good for early appointments.",
      icon: "ri-government-line",
    },
    {
      id: "fh-5",
      name: "Broomfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2800 W 120th Ave",
      city: "Broomfield",
      state: "CO",
      zip: "80020",
      phone: "(303) 466-0170",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 5 miles northwest of Federal Heights, in Broomfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northern acceptance facility near the Flatiron Crossing area. Good parking. Serves the Federal Heights-Broomfield corridor.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 25-mile drive to Aurora via US-36/I-225", fpc: "No — ship from Federal Heights area" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "US-36/I-25 Interchange", agency: "Major bottleneck during rush hour", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until Peak Summer Season",
      description: "Summer is Federal Heights' busiest time — Water World draws visitors from across the metro area. Routine passport processing takes 8–11 weeks. Start expedited service at least 4 weeks before summer travel.",
    },
    {
      icon: "ri-image-line",
      title: "Using Non-Compliant Photos",
      description: "Nearby photo services may not follow the latest State Department guidelines. Passport photos must be exactly 2×2 inches on a white or off-white background — no glasses, neutral expression, no shadows.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Checking Facility Hours",
      description: "Federal Heights doesn't have its own passport acceptance facility within city limits. The nearest is Northglenn Post Office (2 miles north). Check locations and hours before heading out — not all nearby facilities offer passport services.",
    },
    {
      icon: "ri-car-line",
      title: "Underestimating US-36 Connector Traffic",
      description: "The US-36/I-25 interchange is one of Colorado's busiest highway junctions. Driving from Federal Heights to the Aurora passport agency means navigating this interchange — a 25-minute drive can easily become 45+ minutes during rush hour.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Country-Specific Requirements",
      description: "Many Federal Heights residents have family ties to Latin America. Different countries have different passport validity requirements beyond the standard 6-month rule. Always verify country-specific entry requirements.",
    },
    {
      icon: "ri-file-warning-line",
      title: "Not Having Proper Documentation for Name Changes",
      description: "After marriage, divorce, or legal name changes, Federal Heights residents often forget to bring the proper documentation when applying. Marriage certificates, divorce decrees, and court orders must be certified copies — not photocopies.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Federal Heights or Adams County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Northglenn, Westminster, or Thornton." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Adams County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no US-36/I-25 interchange battle required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Federal Heights address — trackable every step." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Federal Heights, CO?", a: "Fast Passport Center offers emergency passport processing in Federal Heights, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to navigate the US-36/I-25 interchange to the Aurora passport agency." },
    { q: "Does Federal Heights have its own passport acceptance facility?", a: "No — Federal Heights does not have a dedicated passport acceptance facility within city limits. The nearest options are Northglenn Post Office (2 miles north), Westminster Post Office (3 miles west), and Thornton Post Office (4 miles east) — all within a short drive." },
    { q: "What if I live near Water World or along Federal Boulevard?", a: "Absolutely. Fast Passport Center serves all of Federal Heights. Our service works the same way whether you're near Water World on 90th Avenue, along the Federal Boulevard corridor, or anywhere else in the city. Ship your documents from nearby UPS or FedEx — we handle the rest." },
    { q: "Can you help with passports for families visiting relatives internationally?", a: "Yes. Many Federal Heights residents travel to Mexico and Latin America to visit family. Fast Passport Center understands the unique needs of family travelers — including multi-passport family bundles and child passport processing." },
    { q: "How much does an expedited passport cost in Federal Heights, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos near Federal Heights?", a: "Walgreens and King Soopers in nearby Northglenn and Westminster offer passport photo services. UPS Store in Thornton and FedEx Office in Westminster also provide photos. All are within a 5-minute drive. Photos must be 2×2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve the entire Federal Heights-Northglenn-Westminster area?", a: "Yes. Fast Passport Center serves the full northern metro corridor including Federal Heights, Northglenn, Westminster, Thornton, Broomfield, and all surrounding Adams County communities. Our courier service covers this entire region." },
    { q: "Is Federal Heights close to Denver International Airport?", a: "Federal Heights is approximately 30 minutes from Denver International Airport via US-36 and E-470 — about 25 miles. Our courier service ensures your passport is ready well before you need to make that airport drive." },
  ],
  photoLocations: [
    { name: "Walgreens — Northglenn", address: "10500 Melody Dr, Northglenn, CO 80234", hours: "Mon–Sun: 8AM–9PM", website: "https://www.walgreens.com/storelocator" },
    { name: "King Soopers — Northglenn", address: "500 E 120th Ave, Northglenn, CO 80233", hours: "Mon–Sun: 6AM–11PM", website: "https://www.kingsoopers.com/stores" },
    { name: "UPS Store — Thornton", address: "3901 E 120th Ave, Thornton, CO 80233", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/tools/find-a-store" },
    { name: "FedEx Office — Westminster", address: "7353 Federal Blvd, Westminster, CO 80030", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM", website: "https://www.fedex.com/en-us/location.html" },
  ],
  dmvLocations: [
    { name: "DMV — Thornton (Adams County)", address: "11940 Colorado Blvd, Thornton, CO 80233", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV in Thornton for northern Adams County residents. REAL ID and driver's license renewals. Approximately 5 miles from Federal Heights.", featured: true },
    { name: "DMV — Westminster (Jefferson County)", address: "8452 Federal Blvd, Westminster, CO 80031", hours: "Mon–Fri: 8AM–5PM", note: "DMV serving the Federal Heights-Westminster corridor. REAL ID processing available. Convenient Federal Boulevard access.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "25 miles east via US-36 and E-470 — approximately 30 minutes",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Convenient for Federal Heights via US-36 east to E-470.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "BJC",
      name: "Rocky Mountain Metropolitan Airport",
      distance: "12 miles northwest via US-36 — approximately 15–20 minutes",
      address: "11755 Airport Way, Broomfield, CO 80021",
      note: "General aviation and corporate airport serving the northern metro area. No scheduled commercial service. Private and charter flights only. Most convenient airport for Federal Heights residents.",
      flightUrl: "https://www.flyrmm.com/",
      flightLabel: "BJC Flight Info",
      featured: false,
    },
  ],
};